export const FILE_SIZE = 500 * 1024;
export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
];
export const SUPPORTED_TYPES = [ '.jpg', '.jpeg', '.png' ];
